/** Nút nổi tròn kiểu Quy Trình — mở chatbot BSC / Hub. */
import React from 'react';
import { Tooltip } from 'antd';

export interface AiAssistantBubbleProps {
  title?: string;
  onClick: () => void;
  disabled?: boolean;
}

export const AiAssistantBubble: React.FC<AiAssistantBubbleProps> = ({
  title = 'Trợ lý BSC',
  onClick,
  disabled,
}) => (
  <Tooltip title={disabled ? undefined : title} placement="left">
    <span className="fixed bottom-6 right-6 z-[1100]">
      <button
        type="button"
        aria-label={title}
        disabled={disabled}
        onClick={onClick}
        className="flex h-12 w-12 items-center justify-center rounded-full border-0 bg-[#0c68e9] text-white shadow-[0_4px_16px_rgba(12,104,233,0.45)] hover:brightness-110 active:brightness-95 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:brightness-100"
      >
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden>
          <path
            d="M6.2 5.4h11.6A2.2 2.2 0 0 1 20 7.6v7.1a2.2 2.2 0 0 1-2.2 2.2h-6.1L8 20.2v-3.3H6.2A2.2 2.2 0 0 1 4 14.7V7.6a2.2 2.2 0 0 1 2.2-2.2Z"
            stroke="#fff"
            strokeWidth="1.7"
            strokeLinejoin="round"
          />
          <circle cx="9.4" cy="10.4" r="1" fill="#fff" />
          <circle cx="14.6" cy="10.4" r="1" fill="#fff" />
          <path d="M9.3 13c1.2 1 4.2 1 5.4 0" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" />
        </svg>
      </button>
    </span>
  </Tooltip>
);

export default AiAssistantBubble;
